/**
 * Generic map control controls. Wherever possible use this when you need a map.
 *
 * Only works with 1 map per page currently - so if you'd like another, you'll
 * have to do something else.
 *
 * Add a <div> with an ID of "inoria-map" wherever you'd like on your
 * page. This library will set it's height (defaulting to 600px and other
 * settings).
 *
 * Feel free to update this to support multiple maps, if you need :)
 */

window.MAPS = {
    options: {
        mapHeight: '800px',
        mapContainerId: 'inoria-map',
    },
    map: undefined,
    init: function (options) {
        _.extend(window.MAPS.options, options);
        return window.MAPS.initMap(window.MAPS.options.mapContainerId);
    },
    initMap: function (mapContainerId) {
        return (new Promise(function (resolve, reject) {
            document.getElementById('inoria-map').style.height = window.MAPS.options.mapHeight;

            window.MAPS.map = L.map(mapContainerId);
            window.MAPS.map.setView([51.606802, -0.240155], 11.5);

            // Add the streets
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>',
                maxZoom: 18,
                id: 'openstreetmap.streets',
            }).addTo(window.MAPS.map);

            window.MAPS.map.whenReady(function (e) {
                window.MAPS.initFullScreen(window.MAPS.map);
                resolve();
            });

        })).catch(error => console.error(error));
    },
    initFullScreen: function (map) {
        // Add a FullScreen button.
        L.control.fullscreen({}).addTo(map);
    },
}
